import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import {  Response, Headers, ResponseContentType, RequestMethod } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable, Subject } from 'rxjs';
import { Facture, Produit, Facturedetail, Socifact, Devise } from '../entity/Facture';
import { FilterSuivi } from '../entity/Filter';
import { Pjoint } from '../entity/Pjoint';
import { environment } from 'src/environments/environment.prod';
import { Client } from '../entity/exhibitor';
import { MessageService } from 'primeng/api';

import { catchError, tap } from 'rxjs/operators';
import { AnonymeEntity } from '../entity/AnonymeEntity';
import { Anonyme } from '../entity/Anonyme';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class FactureService {


  private url: string = environment.restApi + 'facture/download';

  private apiFacturation = environment.restApi + 'facture/';
  private baseUrl = environment.restApi;

  private baseUrl1: string = environment.restApiCRM;
  constructor(private messageService: MessageService, private http: HttpClient ) {

  }

  get(id: Number): Observable<Facture> {
    const pavi$ = this.http
      .get<Facture>(this.apiFacturation + id, httpOptions);


    return pavi$;
  }

  createContractIfNotExiste(idParticipant: number): Observable<any> {
    return this.http.post(this.apiFacturation + "createContractIfNotExiste/" + idParticipant, httpOptions);
  }

  findContract(idParticipant: number): Observable<Facture> {
    const pavi$ = this.http
      .get<Facture>(this.apiFacturation + 'findContractParticipant/' + idParticipant, httpOptions);


    return pavi$;
  }



  getGroupes(): Observable<String[]> {
    const facture$ = this.http
      .get(this.apiFacturation + 'getGroupes', httpOptions).map((results: Response) => results.json());
    return facture$;
  }
  getPercents(): Observable<string[]> {
    const facture$ = this.http
      .get(this.apiFacturation + 'getPercents', httpOptions).map((results: Response) => results.json());
    return facture$;
  }


  findByGroupe(groupe: string): Observable<Facture[]> {
    const facture$ = this.http
      .get(this.apiFacturation + 'findByGroupe/' + groupe, httpOptions).map((results: Response) => results.json());
    return facture$;
  }
  printFactureProforma(facture: Facture, isAnglais: boolean): any {
    return this.http.get(this.apiFacturation + 'printFactureProforma/' + isAnglais +
      '/' + facture.idfacture, { responseType: "blob"});
  
  }
  printFactureProformaSign(facture: Facture, isAnglais: boolean ,isSignature:boolean): any {
    return this.http.get(this.apiFacturation + 'printFactureProformaSign/' + isAnglais +"/"+isSignature+
      '/' + facture.idfacture, { responseType: "blob"});
  
  }
  pjointFile1(pjoint: Pjoint): any {

    // let pjoint$ = this.http.get<Modelcores>(`${this.baseUrl1}pjoint/findPjoint/` + pjoint.pjointeId )
    // return pjoint$;
   //}
   const pjoint$ = this.http    .get (`${this.baseUrl1}facture/xyz/${pjoint.pjointeId}` , { responseType: "blob"} )  ;
     return pjoint$;
   }
 

  printPersonaliser(facture: Facture, isAnglais: boolean, isSignature: boolean, c1: string, c2: string, c3: string,isWOrd:boolean): any {
 if(!isWOrd){
  if (c1.length == 0) c1 = 'c1'; if (c2.length == 0) c2 = 'c2'; if (c3.length == 0) c3 = 'c3';
  //console.log(this.apiFacturation + 'printPdf/' + isAnglais + '/' + isSignature + '/' + c1 + '/' + c2 + '/' + c3 + '/' + facture.idfacture);

  return this.http.get(this.apiFacturation + 'printPdf/' + isAnglais + '/' + isSignature + '/' + c1 + '/' + c2 + '/' + c3 +
    '/' + facture.idfacture, { responseType: "blob"});
 }
 else
 return this.printPersonaliserDocx(facture,isAnglais,isSignature)
 
    
  }
  printPersonaliserDocx(facture: Facture, isAnglais: boolean, isSignature: boolean ): any {
    
    //console.log(this.apiFacturation + 'printPdf/' + isAnglais + '/' + isSignature + '/' + c1 + '/' + c2 + '/' + c3 + '/' + facture.idfacture);

    return this.http.get(this.apiFacturation + 'printDocx/' + isAnglais    + '/' + facture.idfacture, { responseType: "blob"});
  }


  printFacture(facture: Facture, isAnglais: boolean): any {
    return this.http.get(this.apiFacturation + 'printPdf/' + isAnglais +
      '/' + facture.idfacture,  { responseType: "blob"});
  }
  pjointFile(pjoint: Pjoint, subFolder: string): Observable<any>  {

    const pjoint$ = this.http.get(`${this.baseUrl}pjoint/findPjoint/` + subFolder + "/" +
      pjoint.pjointeId, { responseType: "blob"})  ;
    return pjoint$;
  }

  removePjoint(pjoint: Pjoint): Observable<any> {
    return this.http.delete(`${this.baseUrl}pjoint/` + pjoint.pjointeId);

  }

  /*
    printPersonaliser(facture: Facture, isAnglais: boolean, isSignature: boolean, c1: string, c2: string, c3: string): any {
      if (c1.length == 0) c1 = 'c1'; if (c2.length == 0) c2 = 'c2'; if (c3.length == 0) c3 = 'c3';
  //console.log('isSignature'+isSignature);
  
      return this.http.get(this.apiFacturation + '/printPdf/' + isAnglais + '/' + isSignature + '/' + c1 + '/' + c2 + '/' + c3 +
        '/' + facture.idfacture, { responseType: ResponseContentType.Blob, headers: this.getHeaders1() }).map(
          (res) => {
            return new Blob([res.blob()], { type: 'application/pdf' });
          });
    }
  
    printFacture(facture: Facture, isAnglais: boolean): any {
      return this.http.get(this.apiFacturation + '/printPdf/' + isAnglais +
        '/' + facture.idfacture, { responseType: ResponseContentType.Blob, headers: this.getHeaders1() }).map(
          (res) => {
            return new Blob([res.blob()], { type: 'application/pdf' });
          });
    }
    printReclamation(prospect: Prospect, lieu: string, titre: string): any {
      return this.http.get(this.apiFacturation + '/printReclamation/' + prospect.prospectId + '/' + lieu + '/' + titre, { responseType: ResponseContentType.Blob, headers: this.getHeaders1() }).map(
        (res) => {
          return new Blob([res.blob()], { type: 'application/pdf' });
        });
    }
    printMass(factures: Facture[]): any {
      return this.http.post(this.apiFacturation + '/printMass/', factures, { responseType: ResponseContentType.Blob }).map(
        (res) => {
          return new Blob([res.blob()], { type: 'application/zip' });
        });
    }
   
    exportFacture(facture: Facture, isAnglais: boolean): any {
      return this.http.get(this.apiFacturation + '/printDocx/' + isAnglais +
        '/' + facture.idfacture, { responseType: ResponseContentType.Blob }).map(
          (res) => {
            return new Blob([res.blob()], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
          });
    }
    downloadPDF(): any {
      return this.http.get(this.url, { responseType: ResponseContentType.Blob, headers: this.getHeaders1() }).map(
        (res) => {
          return new Blob([res.blob()], { type: 'application/pdf' });
        });
    }
    downloadFile() {
  
      this.http.get(this.apiFacturation + '/download', { headers: this.getHeaders1() }).subscribe(
        (response) => {
          const resSTR = JSON.stringify(response);
          const resJSON = JSON.parse(resSTR);
          const mediaType = 'application/pdf';
          const blob = new Blob([resJSON._body], { type: mediaType });
          const filename = 'test.pdf';
        });
    }
  */
  private getHeaders1() {
    const headers = new Headers();
    headers.append('Accept', 'application/pdf');
    headers.append('Content-Type', 'application/pdf');
    return headers;
  }

  getAll(): Observable<Facture[]> {
    const facture$ = this.http
      .get<Facture[]>(this.apiFacturation, httpOptions);
    return facture$;
  }
  getAllClasser(): Observable<Facture[]> {
    const facture$ = this.http
      .get<Facture[]>(this.apiFacturation + 'getAllClasser', httpOptions);
    return facture$;
  }
  getAllFactures(): Observable<Facture[]> {
    const facture$ = this.http
      .get<Facture[]>(this.apiFacturation + 'getAllFactures', httpOptions);
    return facture$;
  }
  findByClient(idProspect: number): Observable<Facture[]> {
    const facture$ = this.http
      .get<Facture[]>(this.apiFacturation + 'findByClient/' + idProspect, httpOptions);

    return facture$;
  }
  findByParticipant(idParticipant: number): Observable<Facture[]> {
    const facture$ = this.http
      .get<Facture[]>(this.apiFacturation + 'findByParticipant/' + idParticipant, httpOptions);

    return facture$;
  }
  findByClientProforma(idProspect: number): Observable<Facture[]> {
    const facture$ = this.http
      .get<Facture[]>(this.apiFacturation + 'findByClientProforma/' + idProspect, httpOptions);

    return facture$;
  }
  getAllProduits(): Observable<Produit[]> {
    const produit$ = this.http
      .get<Produit[]>(`${this.baseUrl}` + 'produit', httpOptions);
    return produit$;
  }
  editProduit(produit: Produit): Observable<Produit > {
    return  this.http.put<Produit>(`${this.baseUrl}produit/${produit.produitId}`, produit);
  }
  addProduit(produit: Produit) : Observable<Produit >{
 return   this.http.post<Produit>(`${this.baseUrl}produit`, produit);
  }
  removeProduit(produit: Produit) : Observable<Produit >{
    return   this.http.delete<Produit>(`${this.baseUrl}produit/${produit.produitId}` );
     }

  getAllLogistique(idClient: number): Observable<Anonyme> {
    return this.http
      .get<Anonyme>(`${this.apiFacturation}` + 'getAllLogistique/' + idClient, httpOptions);

  }

  getAllProduitsFact(facture: Facture): Observable<Produit[]> {
    const produit$ = this.http
      .get<Produit[]>(`${this.baseUrl}` + 'facturedetail/produit/' + facture.idfacture, httpOptions);
    return produit$;
  }
  findByClientFacture(idClient: number): Observable<Facturedetail[]> {
    const produit$ = this.http
      .get<Facturedetail[]>(`${this.baseUrl}facturedetail/findByClientFacture/${idClient}`, httpOptions);
    return produit$;
  }

  getAllSociFactOrder(): Observable<Socifact[]> {
    const socifact$ = this.http
      .get<Socifact[]>(`${this.baseUrl}` + 'socifact/getAllSociFactOrder', httpOptions);
    return socifact$;
  }


  getAllSociFact(): Observable<Socifact[]> {
    const socifact$ = this.http
      .get<Socifact[]>(`${this.baseUrl}` + 'socifact/', httpOptions);
    return socifact$;
  }
  getAllDevise(): Observable<Devise[]> {
    const devises$ = this.http
      .get<Devise[]>(`${this.apiFacturation}` + 'devise/', httpOptions);
    return devises$;
  }
  selectedProduits(idFacture: Number, produits: Produit[]): Observable<Response> {
    return this.http.post<Response>(`${this.baseUrl}` + 'facturedetail/selectedProd/' + idFacture, JSON.stringify(produits), httpOptions);
  }
  selectedOneProd(idFacture: Number, produit: Produit): Observable<Response> {
    return this.http.post<Response>(`${this.baseUrl}` + 'facturedetail/selectedOneProd/' + idFacture, produit, httpOptions);
  }
  saveAllDetailFacture(idFacture: Number, facturedetails: Facturedetail[]): Observable<Response> {
    return this.http.post<Response>(`${this.baseUrl}` + 'facturedetail/saveAllDetailFacture/' +
      idFacture, JSON.stringify(facturedetails), httpOptions);
  }
  changeDevise(idFacture: Number, devise: string, facturedetails: Facturedetail[]): Observable<Response> {
    return this.http.post<Response>(`${this.baseUrl}` + 'facturedetail/changeDevise/' +
      idFacture + '' + devise, JSON.stringify(facturedetails), httpOptions);
  }
  getAllDetailFacture(idFacture: Number): Observable<Facturedetail[]> {
//console.log("getAllProduits",`${this.baseUrl}` + 'facturedetail/facture/' + idFacture);


    const factureDetails$ = this.http
      .get<Facturedetail[]>(`${this.baseUrl}` + 'facturedetail/facture/' + idFacture, httpOptions);
    return factureDetails$;
  }
  filterRange(filterSuivi: FilterSuivi, from: number, to: number): Observable<Facture[]> {
    //console.log("fileter range service");

    let factures$ = this.http
      .post<Facture[]>(this.apiFacturation + 'filterRange' + '/' + from + '/' + to, filterSuivi, httpOptions);
    return factures$;
  }
  filterAll(filterSuivi: FilterSuivi): Observable<Facture[]> {
    let factures$ = this.http
      .post<Facture[]>(this.apiFacturation + 'filterAll', filterSuivi, httpOptions);
    return factures$;
  }
  filterRangeFF(filterSuivi: FilterSuivi, from: number, to: number): Observable<Facture[]> {
    //console.log("fileter range service");

    let factures$ = this.http
      .get<Facture[]>(this.apiFacturation + '' + from + '/' + to, httpOptions);
    return factures$;
  }
  countFilter(filterSuivi: FilterSuivi): Observable<Response> {
    return this.http.post<Response>(this.apiFacturation + 'countFilter', filterSuivi)
  }
  remove(facture: Facture): Observable<Response> {

    return this.http.delete<Response>(this.apiFacturation + facture.idfacture, httpOptions);

  }
  create(facture: Facture): Observable<Facture> {

    return this.http.post<Facture>(this.apiFacturation, facture, httpOptions);

  }
  save(facture: Facture): Observable<Facture> {
    return this.http.put<Facture>(this.apiFacturation + facture.idfacture, facture, httpOptions).pipe(
      tap(_ => this.notify(`updated facture id=${facture.idfacture}`, 'PUT')),
      catchError(this.handleError('updatefacture', 'PUT'))
    );;
  }

  validerFacture(facture: Facture): Observable<Response> {
    const userID: Number = JSON.parse(localStorage.getItem('currentUser')).userId;
    return this.http.put<Response>(`${this.apiFacturation}validerFacture/${facture.idfacture}/${userID}`, JSON.stringify(facture), httpOptions);
  }
  avoirFacture(facture: Facture): Observable<Facture> {
    const userID: Number = JSON.parse(localStorage.getItem('currentUser')).userId;
    return this.http.put<Facture>(`${this.apiFacturation}avoirFacture/${facture.idfacture}/${userID}`, JSON.stringify(facture), httpOptions);
  }
  saveDetail(facturedetail: Facturedetail): Observable<Response> {
    return this.http.put<Response>(`${this.baseUrl}` + 'facturedetail/' +
      facturedetail.idfacturedetail, JSON.stringify(facturedetail), httpOptions);
  }
  removeDetail(facturedetail: Facturedetail): Observable<Response> {
    return this.http.delete<Response>(`${this.baseUrl}` + 'facturedetail/' + facturedetail.idfacturedetail, httpOptions);
  }

  private subject = new Subject<any>();
  private subjecteditInvoice = new Subject<any>();

  nextEditInvoice(invocie: Facture) {
    this.subject.next(invocie);
  }
  getEditedInvoice(): Observable<Facture> {
    return this.subject.asObservable();
  }
  selectInvoice(invoice: Facture) {
    this.subject.next(invoice);
  }

  nextInvoice(invocie: Facture) {
    this.subject.next(invocie);
  }

  getSelectedInvoice(): Observable<Facture> {
    return this.subject.asObservable();
  }

  protected handleError(operation: string, method: string) {
    return function errorHandler(res: HttpErrorResponse) {

      //   this.logger.error(res);
      // const eMsg = res.message || '';
      /* const error = `${this.entityNamePlural} ${operation} Error${
           eMsg ? ': ' + eMsg : ''
           }`;*/
      this.messageService.add({ severity: 'error', summary: "Vous n'etes pas entrain d'ecrire", detail: "Veuillez contacter votre support" });

    }.bind(this);
  }
  protected notify(message: string, method: string) {
    // this.messageService.add({severity:'success', summary:method, detail:message});
  }

}












function mapDevises(response: Response): Devise[] {
  return response.json().map(toDevise);
}
function toDevise(r: any): Devise {
  return r;
}
